import { Tag } from 'antd'

import { SpecimenLaboratoryStatus, SpecimenStatus } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status?: SpecimenLaboratoryStatus | null
  testStatus?: SpecimenStatus | null
}

const InvestigationStatusMap = {
  [SpecimenLaboratoryStatus.RECEIVED]: 'warning',
  [SpecimenLaboratoryStatus.INCONFORM]: 'error',
  [SpecimenLaboratoryStatus.SENT_TO_VALIDATION]: 'processing',
  [SpecimenLaboratoryStatus.VALIDATED]: 'success',
  [SpecimenLaboratoryStatus.REJECTED]: 'error'
}
export const LaboratoryStatusTag = ({ status, testStatus }: Props) => {
  const { t } = useLocales()

  const color =
    InvestigationStatusMap[status ?? SpecimenLaboratoryStatus.RECEIVED]

  const isTestSendToMedic =
    status === SpecimenLaboratoryStatus.VALIDATED &&
    testStatus === SpecimenStatus.COMPLETED

  return (
    <Tag color={color}>
      {isTestSendToMedic
        ? t('tests.testDone')
        : t(
            `tests.laboratory_statuses.${status ?? SpecimenLaboratoryStatus.RECEIVED}`
          )}
    </Tag>
  )
}
